import { render, staticRenderFns } from "./header.vue?vue&type=template&id=6a123b5b&scoped=true&lang=pug&"
import script from "./header.vue?vue&type=script&setup=true&lang=js&"
export * from "./header.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./header.vue?vue&type=style&index=0&id=6a123b5b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a123b5b",
  null
  
)

export default component.exports